<p-table [totalRecords]="trainingRecordDocuments?.length" #dt [value]="trainingRecordDocuments" styleClass="p-datatable-striped"
         [scrollable]="!isOnMobile &&    trainingRecordDocuments?.length > 5" scrollHeight="500px"
         [globalFilterFields]="['documentType', 'originalFilename', 'trainingType.description', 'operativeFullName']">
  <ng-container *ngIf="showTableCaption">
    <ng-template pTemplate="caption">
      <div class="table-header">
        <div class="view" style="height: 65px; color: white">
          <div class="as-of-date-container">
            <div class="container-fluid">
              <div class="row">
                <div class="col">
                  <div class="row  align-items-center eca-primary-text">
                    <div class="col-auto  align-items-center">
                      <h5 class="h5-responsive" style="display: contents">
                        <strong *ngIf="showHeaderText">{{headerText}}</strong>
                        <app-eca-ghost-btn (btnClicked)="addDocumentClicked()" *ngIf="showAddDocumentButton" [btnText]="addDocumentButtonText" btnIcon="file-plus" btnType="success"></app-eca-ghost-btn>
                      </h5>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="float-right">
                    <div class="as-of-date-container" style="margin-top: 5px; margin-right: 5px">
                      <span class="eca-primary-text" style="font-size: 1.2rem; margin-right: 5px">As of</span>
                      <div style="margin-right: 10px">
                        <input type="date" class="form-control">
                      </div>
                      <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                             <input pInputText type="text" class="form-control" id="ctrlSearchInput"
                                    placeholder="Search All"
                                    (input)="dt.filterGlobal($event.target.value, 'contains')">
                        </span>
                      <app-eca-ghost-btn btnIcon="file-excel" btnText="Export" btnType="primary"></app-eca-ghost-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </ng-template>
  </ng-container>
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 8rem;" pSortableColumn="documentType">
        Type
        <p-sortIcon field="documentType"></p-sortIcon>
      </th>
      <th style="width: 8rem;" pSortableColumn="trainingType.description">
        Training Type
        <p-sortIcon field="trainingType.description"></p-sortIcon>
      </th>
      <th style="width: 10rem;" pSortableColumn="operativeFullName">
        Operative Name
        <p-sortIcon field="operativeFullName"></p-sortIcon>
      </th>
      <th style="width: 8rem;" pSortableColumn="documentCreationDate?.dateTime">
        Created On
        <p-sortIcon field="documentCreationDate?.dateTime"></p-sortIcon>
      </th>
      <th style="width: 8rem;" pSortableColumn="review?.dateTime">
        Review Due
        <p-sortIcon field="review?.dateTime"></p-sortIcon>
      </th>
      <th style="width: 8rem;" pSortableColumn="expiryDate?.dateTime">
        Expires On
        <p-sortIcon field="expiryDate?.dateTime"></p-sortIcon>
      </th>
      <th style="width: 10rem;" pSortableColumn="originalFilename">
        Original Filename
        <p-sortIcon field="originalFilename"></p-sortIcon>
      </th>
      <th style="width: 10rem;" pSortableColumn="totalObervations">
        Obervations
        <p-sortIcon field="totalObervations"></p-sortIcon>
      </th>
      <th style="font-weight: bold; width: 8rem;"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-trainingRecordDocument style="margin: 15px;">
    <tr>
      <td>{{ trainingRecordDocument?.documentType }}</td>
      <td>{{ trainingRecordDocument.trainingType.description }}</td>
      <td> <a [routerLink]="'/operative/' + trainingRecordDocument?.operativeId">{{ trainingRecordDocument?.operativeFullName }} </a>  </td>
      <td>{{ trainingRecordDocument?.documentCreationDate?.dateTime | date: 'dd/MM/yyyy' }}</td>
      <td>{{ trainingRecordDocument?.reviewDate?.dateTime | date: 'dd/MM/yyyy' }}</td>
      <td>{{ trainingRecordDocument?.expiryDate?.dateTime | date: 'dd/MM/yyyy' }}</td>
      <td>{{ trainingRecordDocument?.originalFilename }}</td>
      <td>{{ trainingRecordDocument?.totalObervations }}</td>
      <td>
        <div class="text-center">
          <app-eca-row-menu (viewBtnClicked)="viewDocumentClicked(trainingRecordDocument)"
                            [rowMenuItems]="rowMenuItems"
                            [contextItem]="trainingRecordDocument">
          </app-eca-row-menu>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
